import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=bf660b86&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf660b86')) {
      api.createRecord('bf660b86', component.options)
    } else {
      api.reload('bf660b86', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=bf660b86&", function () {
      api.rerender('bf660b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FmzVCxiUafDv/JS/comp/ImgFallback.vue"
export default component.exports